import { Dumbbell, HelpCircle, Sparkles, ClipboardList } from "lucide-react";

type Props = {
  subject?: string;
  onAction: (prompt: string) => void;
  disabled?: boolean;
  allowed?: string[];
};

const actions = [
  { key: "exercice", label: "Exercice", icon: Dumbbell, prompt: "Propose-moi un exercice sur ce qu'on vient de voir." },
  { key: "quiz", label: "Quiz", icon: HelpCircle, prompt: "Fais-moi un quiz rapide sur cette notion." },
  { key: "simple", label: "Plus simple", icon: Sparkles, prompt: "Explique-moi ça plus simplement, comme si j'avais 10 ans." },
  { key: "resume", label: "Résumé", icon: ClipboardList, prompt: "Résume ce qu'on vient de voir en quelques points clés." },
];

const ChatActionButtons = ({ subject, onAction, disabled, allowed }: Props) => {
  // Hidden by default — the AI decides which actions to surface via <kelasai_meta>.actions
  if (!allowed || allowed.length === 0) return null;
  const normalized = allowed.map((a) => a.toLowerCase().trim());
  const visible = actions.filter((a) => normalized.includes(a.key));
  if (visible.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5 mt-2">
      {visible.map((action) => {
        const Icon = action.icon;
        return (
          <button
            key={action.label}
            onClick={() => onAction(action.prompt)}
            disabled={disabled}
            className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-xl text-xs font-bold bg-primary/10 text-primary hover:bg-primary/20 transition-colors border border-primary/20 disabled:opacity-40"
          >
            <Icon className="w-3 h-3" />
            {action.label}
          </button>
        );
      })}
    </div>
  );
};

export default ChatActionButtons;
